/**
 * Pending changes slice (SCRUM-1951, RTK bundle 2) — the former switch reducer
 * pendingChangesReducer.js as createSlice. Behaviour-preserving: every case
 * answers the same legacy action type string (pendingChangesTypes.js) that
 * pendingChangesActions.js already dispatches, and returns the same state.
 * The actions module is unchanged, so no importer changes.
 * Characterised by tests/integration/reducers/reviewPublishingReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  GET_PENDING_CHANGES,
  APPROVE_PENDING_CHANGE,
  REJECT_PENDING_CHANGE,
  CLEAR_CHANGES_MESSAGE,
  GET_ENTITY_PENDING_CHANGE,
  CLEAR_ENTITY_PENDING_CHANGE,
} from "./pendingChangesTypes";

type PendingChangesState = {
  pendingChanges: any[];
  entityPendingChange: any;
  message: string;
};

const initialState: PendingChangesState = {
  pendingChanges: [],
  entityPendingChange: null,
  message: "",
};

/** Approve and reject answer alike: the decided row replaces its pending copy. */
const decided = <T extends string>(state: PendingChangesState, action: PayloadAction<{ msg: string; change: any }, T>) => ({
  ...state,
  message: action.payload.msg,
  pendingChanges: state.pendingChanges.map((c) =>
    c._id === action.payload.change._id ? action.payload.change : c
  ),
});

const pendingChangesSlice = createSlice({
  name: "pendingChanges",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CLEAR_CHANGES_MESSAGE, (state) => ({ ...state, message: "" }))
      .addCase(GET_PENDING_CHANGES, (state, action: PayloadAction<PendingChangesState["pendingChanges"], typeof GET_PENDING_CHANGES>) => ({
        ...state,
        pendingChanges: action.payload,
      }))
      .addCase(APPROVE_PENDING_CHANGE, decided<typeof APPROVE_PENDING_CHANGE>)
      .addCase(REJECT_PENDING_CHANGE, decided<typeof REJECT_PENDING_CHANGE>)
      .addCase(GET_ENTITY_PENDING_CHANGE, (state, action: PayloadAction<PendingChangesState["entityPendingChange"], typeof GET_ENTITY_PENDING_CHANGE>) => ({
        ...state,
        entityPendingChange: action.payload,
      }))
      .addCase(CLEAR_ENTITY_PENDING_CHANGE, (state) => ({ ...state, entityPendingChange: null }));
  },
});

export default pendingChangesSlice.reducer;
